import { useEffect } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

import usePaginatedCookingSessions from "../../hooks/usePaginatedCookingSessions";
import useScrollPositionRestoration from "../../hooks/useScrollPositionRestoration";
import styles from "./CookingHistoryList.module.css"
import CookingHistoryListSkeleton from "./CookingHistoryListSkeleton";
import EmptyCookingHistory from "./EmptyCookingHistory";
import RatingsCard from "./RatingsCard";

const CookingHistoryList = () => {
  const { sessions, loadMore, loading } = usePaginatedCookingSessions();

  useScrollPositionRestoration("scrollheightCookingHistory", [sessions]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.offsetHeight;

      if (scrollTop + windowHeight >= docHeight - 1) {
        loadMore();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  }, [loadMore]);

  if (!loading && sessions.length === 0) {
    return <EmptyCookingHistory />
  }

  if (loading && sessions.length === 0) {
    return <CookingHistoryListSkeleton />
  }

  return (
    <Grid className={styles.box} >
      {sessions.map((sess) => (
        <RatingsCard key={sess.sessionID} sess={sess} />
      ))}
      <Grid className={styles.loader}>
        {loading && <CircularProgress />}
      </Grid>
    </Grid>
  )
}

export default CookingHistoryList